// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1n7QT","header":"styles_header__2E-E0","cancelButton":"styles_cancelButton__QoDpy","confirmButton":"styles_confirmButton__39wQJ"};